import CanceledError from "../cancel/CanceledError.js";
import AxiosError from "../core/AxiosError.js";
import utils from '../utils.js';
var composeSignals = function (signals, timeout) {
    var length = (signals = signals ? signals.filter(Boolean) : []).length;
    if (timeout || length) {
        var controller_1 = new AbortController();
        var aborted_1;
        var onabort_1 = function (reason) {
            if (!aborted_1) {
                aborted_1 = true;
                unsubscribe_1();
                var err = reason instanceof Error ? reason : this.reason;
                controller_1.abort(err instanceof AxiosError ? err : new CanceledError(err instanceof Error ? err.message : err));
            }
        };
        var timer_1 = timeout && setTimeout(function () {
            timer_1 = null;
            onabort_1(new AxiosError("timeout ".concat(timeout, " of ms exceeded"), AxiosError.ETIMEDOUT));
        }, timeout);
        var unsubscribe_1 = function () {
            if (signals) {
                timer_1 && clearTimeout(timer_1);
                timer_1 = null;
                signals.forEach(function (signal) {
                    signal.unsubscribe ? signal.unsubscribe(onabort_1) : signal.removeEventListener('abort', onabort_1);
                });
                signals = null;
            }
        };
        signals.forEach(function (signal) { return signal.addEventListener('abort', onabort_1); });
        var signal = controller_1.signal;
        signal.unsubscribe = function () { return utils.asap(unsubscribe_1); };
        return signal;
    }
};
export default composeSignals;
